<div class="login-layout d-flex justify-content-center min-vh-100 animated fadeIn neighborhood-background">
    <div class="row flex-column w-100">
        <app-auth-logo></app-auth-logo>

        <div class="container">
            <app-login-form class="auth-form d-flex w-100" [isForwarding]="isForwarding">
                <h2>{{ 'Sign in to your account below.' }}</h2>
            </app-login-form>

            <div *ngIf="!isForwarding" class="d-flex align-items-center justify-content-center pt-3">
                <span class="mr-1">{{ 'Don\'t have an account?' }}</span>
                <app-button type="link"
                            [buttonClasses]="['mr-0']"
                            [routeTo]="['/sign-up']">
                    {{ 'Sign up' }}
                </app-button>
            </div>
        </div>
    </div>
</div>
